import { Autocomplete, type AutocompleteProps, TextField } from "@mui/material";

import { isOption, Option } from "api/common/types/common.types";
import { useFieldContext } from "components/Forms/AppForm";

import ErrorMessage2 from "../../helpers/ErrorMessage2";

type SelectFieldProps = Omit<
  AutocompleteProps<Option | string, false, false, false>,
  "renderInput"
> & {
  options: Option[] | string[];
  label: string;
  required?: boolean;
};

const AutocompleteSelect = ({
  options = [],
  label,
  required = false,
  ...props
}: SelectFieldProps) => {
  const field = useFieldContext<string | Option>();

  return (
    <>
      <Autocomplete
        disablePortal
        size="small"
        options={options}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            error={field.state.meta.errors.length > 0}
            required={required}
          />
        )}
        value={field.state.value || ""}
        onChange={(_e, value) => {
          field.handleChange(value ?? "");
        }}
        selectOnFocus
        clearOnBlur
        handleHomeEndKeys
        getOptionLabel={(option) => (isOption(option) ? option.label : option)}
        {...props}
      />
      <ErrorMessage2 />
    </>
  );
};
export default AutocompleteSelect;
